<template>
  <my-profile-menu-layout>
    <notification-settings></notification-settings>
  </my-profile-menu-layout>
</template>

<script>
  import MyProfileMenuLayout from "@/components/layout/MyProfileMenuLayout";
  import NotificationSettings from '@/components/myprofile/NotificationSettings.vue';
  import CurrentUserMixin from "@/mixins/CurrentUserMixin";

  export default {
    name: "ProfileNotifications",
    data() {
      return {
      }
    },
    mixin: [CurrentUserMixin],
    mounted() {
      this.$store.commit('user/set_current_project_id', this.project_id)
    },
    methods: {
    },
    components: {
      MyProfileMenuLayout, NotificationSettings
    },
  }
</script>

<style scoped>

</style>